import React from "react";
import { Card, Alert } from "react-bootstrap";

function UserManagement() {
  return (
    <div>
      <h2 className="mb-4">
        User Management
      </h2>

      <Alert variant="warning">
        <strong>Admin Feature:</strong> This feature is only available to users with Admin permissions.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>Managing Users</h4>
          <p>
            As an admin, you can view and manage all users in your organization. This includes viewing user details,
            editing user properties, and managing user permissions.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Viewing Users</h4>
          <ol>
            <li>Click <strong>Users</strong> in the Settings section of the left menu</li>
            <li>You'll see a grid of all users in your organization</li>
            <li>Use filters to search for specific users</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>User Information</h4>
          <p>For each user, you can see:</p>
          <ul>
            <li>Name and email address</li>
            <li>User role (Admin, Regular User, etc.)</li>
            <li>Assigned permissions</li>
            <li>Account status (Active, Inactive)</li>
            <li>Last login date</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Editing User Details</h4>
          <ol>
            <li>From the Users grid, select a user</li>
            <li>Click the <strong>Edit</strong> button</li>
            <li>Update the user's information:
              <ul className="mt-2">
                <li>Name</li>
                <li>Email address</li>
                <li>Role</li>
                <li>Permissions</li>
                <li>Account status</li>
              </ul>
            </li>
            <li>Click <strong>Save</strong></li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>User Roles</h4>
          <p>Users can have different roles that determine their access level:</p>
          <ul>
            <li><strong>Regular User</strong> - Can use runbooks, schedulers, variables, and connectors</li>
            <li><strong>Admin</strong> - Can manage users and invitations for their organization, plus all regular user features</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Managing User Permissions</h4>
          <p>
            In addition to roles, you can assign granular permissions to users. Permissions control what specific
            actions users can perform, such as:
          </p>
          <ul>
            <li>runbooks.view, runbooks.create, runbooks.edit, runbooks.execute</li>
            <li>schedulers.view, schedulers.create, schedulers.edit, schedulers.delete</li>
            <li>variables.view, variables.create, variables.edit, variables.delete</li>
            <li>connectors.view, connectors.edit (Note: creating connectors requires Admin role)</li>
          </ul>
          <p className="mt-3">
            See the <strong>Permissions System</strong> help topic for more details.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Deactivating Users</h4>
          <p>
            To temporarily disable a user's access without deleting their account, you can deactivate them.
            Deactivated users cannot log in but their data and configurations are preserved.
          </p>
        </Card.Body>
      </Card>
    </div>
  );
}

export default UserManagement;
